import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { DemoMaterialModule } from '../material-module';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';



@NgModule({
  declarations: [
    LoadingSpinnerComponent
  ],
  imports: [
    CommonModule,
    DemoMaterialModule,
  ],
  exports: [
    LoadingSpinnerComponent,
  ] 
})
export class SharedModule { }
